module.exports = __webpack_public_path__ + "img/logo.ad0204da.png";